// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { Classes, MPDButton } from "src/mpd-library";

import { HTMLDivProps } from "@blueprintjs/core";

import {
  IMultiMediaDropInActiveProps,
  MultiMediaDropInActive
} from "./multimedia-drop-inactive";

import {
  IMultiMediaDropActiveProps,
  MultiMediaDropActive
} from "./multimedia-drop-active";

import { IMultiMediaRecordProps, MultiMediaRecord } from "./multimedia-record";

import "./styles.css";

export interface IMultiMediaActiveProps
  extends HTMLDivProps,
    IMultiMediaDropInActiveProps,
    IMultiMediaDropActiveProps,
    IMultiMediaRecordProps {
  multiMedia: any;
}

export class MultiMediaActive extends React.Component<IMultiMediaActiveProps> {
  public constructor(props: IMultiMediaActiveProps) {
    super(props);
  }

  public render() {
    const {
      className,
      onRecordAudio,
      multiMedia,
      onMultiMediaOnDrop,
      onMultiMediaStateChange
    } = this.props;

    const { state, voice, fileName } = multiMedia;

    const classes = classNames(
      "multimedia-active",
      state !== "init" && Classes.ACTIVE,
      fileName === null && voice.state === null && "drop-active",
      voice.state === "record" && "record-active",
      className
    );
    return (
      <div className={classes}>
        <div className="header">
          <MPDButton
            name="compose-view--exit"
            onClick={e => onMultiMediaStateChange(e, "init")}
          />
        </div>
        <MultiMediaDropInActive
          onMultiMediaOnDrop={onMultiMediaOnDrop}
          multiMedia={multiMedia}
          onRecordAudio={onRecordAudio}
          onMultiMediaStateChange={onMultiMediaStateChange}
        />
        <MultiMediaDropActive multiMedia={multiMedia} />
        <MultiMediaRecord
          multiMedia={multiMedia}
          onRecordAudio={onRecordAudio}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/multimedia/multimedia-active.tsx